// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--IcY+7";
export var navigation = "Layout-module--navigation--ynVhm";
export var loader = "Layout-module--loader--rvJ2l";
export var scroll_icon = "Layout-module--scroll_icon--dLTzf";
export var scroll_icon__wheel_outer = "Layout-module--scroll_icon__wheel_outer--IGFDh";
export var scroll_icon__wheel_inner = "Layout-module--scroll_icon__wheel_inner--NnUaB";
export var scroll_1 = "Layout-module--scroll_1--sMdxp";
export var scroll = "Layout-module--scroll--BsBJj";